export const defaultSeatPickerState = {
    validationErrorMessages: []
};
